import * as React from 'react'

import { Input } from '../../../Shared'
import useModalAccessibility from '../../../Shared/hooks/useModalAccessibility';

const EditionNamingModal = ({ deleteNewEdition, updateName, name, saveNameAndGoToCustomize }) => {
  const { modalRef } = useModalAccessibility(close);
  return (
    <div className="modal-container">
      <div className="modal-background name-lesson-modal-background" />
      <div
        aria-labelledby="nameLessonModalTitle"
        aria-modal="true"
        className="name-lesson-modal quill-modal modal-body"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        <h1 className="title" id="nameLessonModalTitle">Name this edition of the lesson</h1>
        <p className="explanation">You will see the name of your edition when you launch the lesson and it will help you identify this edition from the rest of the editions.</p>
        <Input
          className="bordered large"
          handleChange={updateName}
          id="edition-name"
          label="Edition name"
          placeholder="Enter a name for your edition"
          type="text"
          value={name}
        />
        <div className="form-buttons">
          <button className="quill-button outlined medium green focus-on-light" onClick={deleteNewEdition}>Cancel customization</button>
          <button className="quill-button contained medium green focus-on-light" onClick={saveNameAndGoToCustomize}>Start customizing</button>
        </div>
      </div>
    </div>
  )
}

export default EditionNamingModal
